  <template>
  <div data-testid="task-gl-selection">
    <v-col cols="12" v-if="selectglsLocal && selectglsLocal.length > 0" data-testid="task-gl-selection__selected-wrapper">
      <span class="font-size-lg font-weight-semibold" data-testid="task-gl-selection__selected-title">
        Selected Account
      </span>
      <br />
      <div class="d-flex align-center justify-start flex-wrap " data-testid="task-gl-selection__selected-chips">
        <v-chip
          v-for="glcode in selectglsLocal"
          :key="glcode"
          class="caccounting--text lightpurple mt-1 mx-1 d-flex"
          close
          :disabled="isUserEditable"
          @click:close="removeSelectedGl(glcode)"
          :data-testid="`task-gl-selection__selected-chip-${glcode}`"
        >
          <span>{{ glcode }}</span>
        </v-chip>
      </div>
    </v-col>
    <v-col cols="12" style="height: 10vh" v-if="addeditdata.location && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION" data-testid="task-gl-selection__account-picker">
      <v-menu
        :close-on-content-click="false"
        offset-y
        transition="slide-y-transition"
        ref="accountMenu"
        data-testid="task-gl-selection__menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="all-width align-center border-on justify-space-between select-account__no"
            :disabled="isUserEditable"
            data-testid="task-gl-selection__account-menu-btn"
            ><span data-testid="task-gl-selection__account-menu-btn-label" >Select Account Number</span
            ><v-icon data-testid="task-gl-selection__account-menu-btn-icon">mdi-chevron-down</v-icon></v-btn
          >
        </template>
        
        <v-list
          class="ma-0 d-flex flex-column align-start justify-start all-width pa-2"
          data-testid="task-gl-selection__menu-list"
        >
          <div
            class=""
            style="
              max-height: 45vh;
              min-width: 100%;
              overflow: auto;
              z-index: 13 !important;
              width: 20vh;
            "
            ref="glScrollContainer"
            @scroll="onGlScroll"
            data-testid="task-gl-selection__menu-scroll"
          >
            <lb-string
              label="Search"
              class="all-width"
              v-model="searchcustomfilterLocal"
              hidedetails
              @input="debouncedTbSearch"
              data-testid="task-gl-selection__search"
            />
            <v-simple-table
              dense
              class="all-width mt-2 border-on radius-small"
              data-testid="task-gl-selection__table"
            >
              <thead data-testid="task-gl-selection__thead" class="tableHeaderBg">
                <tr data-testid="task-gl-selection__header-row">
                  <th class="gray-background" data-testid="task-gl-selection__th-select">
                    <v-checkbox
                      class="ma-0 pa-0"
                      hide-details
                      color="caccounting"
                      v-model="selectAllgl"
                      @change="toggleSelectAllGl"
                      data-testid="task-gl-selection__select-all-checkbox"
                    ></v-checkbox>
                  </th>
                  <th class="gray-background" scope="Name" data-testid="task-gl-selection__th-account-no">
                    Account No.
                  </th>
                  <th class="gray-background" scope="columns" data-testid="task-gl-selection__th-account-name">
                    Account Name
                  </th>
                  <th class="gray-background" scope="ref" data-testid="task-gl-selection__th-ref">Ref</th>
                  <th class="gray-background" scope="location" data-testid="task-gl-selection__th-location">
                    {{ $store.state.LocationHeader || "Location" }}
                  </th>
                  <th class="gray-background" scope="opening_amount" data-testid="task-gl-selection__th-opening-amount">
                    Opening Amount
                  </th>
                  <th class="gray-background" scope="transaction" data-testid="task-gl-selection__th-transaction">
                    Transaction
                  </th>
                  <th class="gray-background" scope="audit_entries" data-testid="task-gl-selection__th-audit-entries">
                    Audit Entries
                  </th>
                  <th class="gray-background" scope="closing_amount" data-testid="task-gl-selection__th-closing-amount">
                    Closing Amount
                  </th>
                </tr>
              </thead>
              <tbody data-testid="task-gl-selection__tbody">
                <template v-for="(v, k) in filteredgllist">
                  <tr :key="k" :data-testid="`task-gl-selection__row-${k}`">
                    <td :data-testid="`task-gl-selection__cell-select-${k}`">
                        <v-checkbox
                          class="mt-0"
                          dense
                          label=""
                          :value="String(v.glcode)"
                          v-model="tempGlSelection"
                          multiple
                          hide-details
                          :data-testid="`task-gl-selection__row-checkbox-${k}`"
                        ></v-checkbox>
                    </td>
                    <td :data-testid="`task-gl-selection__cell-account-no-${k}`">{{ v.glcode }}</td>
                    <td :data-testid="`task-gl-selection__cell-account-name-${k}`">{{ v.name }}</td>
                    <td class="d-flex align-center min-height" :data-testid="`task-gl-selection__cell-ref-${k}`">
                      <div
                        v-for="(gg, jj) in v.reference_detail || []"
                        :key="jj"
                        class="d-flex"
                        :data-testid="`task-gl-selection__cell-ref-chip-wrapper-${k}-${jj}`"
                      >
                        <v-chip
                          label
                          class="lightpurple caccounting--text mx-1"
                          :data-testid="`task-gl-selection__cell-ref-chip-${k}-${jj}`"
                          ><span>{{ gg.ref }}</span></v-chip
                        >
                      </div>
                    </td>
                    <td :data-testid="`task-gl-selection__cell-location-${k}`">
                      <div
                        v-for="(vv, kk) in v.location_detail || []"
                        :key="kk"
                        :data-testid="`task-gl-selection__cell-location-item-${k}-${kk}`"
                      >
                        <span class="ml-2" :data-testid="`task-gl-selection__cell-location-name-${k}-${kk}`">{{ vv.name }}</span>
                      </div>
                    </td>
                    <td :data-testid="`task-gl-selection__cell-opening-amount-${k}`">{{ v.opening_amount }}</td>
                    <td :data-testid="`task-gl-selection__cell-transaction-${k}`">{{ v.transaction }}</td>
                    <td :data-testid="`task-gl-selection__cell-audit-entries-${k}`">{{ v.audit_entries }}</td>
                    <td :data-testid="`task-gl-selection__cell-closing-amount-${k}`">{{ v.closing_amount }}</td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
            <!-- Infinite scroll loading indicator -->
            <div v-if="tbLoadingState && filteredgllist.length > 0" class="d-flex justify-center pa-2" data-testid="task-gl-selection__loading-more">
              <v-progress-circular indeterminate size="24" color="primary" />
            </div>
            <div v-if="tbFullyLoadedState && filteredgllist.length > 0" class="text-center grey--text caption pa-1" data-testid="task-gl-selection__all-loaded">
              All records loaded
            </div>
          </div>
          <div class="d-flex align-center all-width justify-end mt-2" data-testid="task-gl-selection__select-actions">
            <v-btn
             
              class="ml-2 white--text"
              color="primary"
              @click="
                addSelectedGls({ skipTrialBalance: true });
                $refs.accountMenu.isActive = false;
              "
              data-testid="task-gl-selection__select-btn"
              ><span>Select</span></v-btn
            >
          </div>
        </v-list>
      </v-menu>
    </v-col>
    <v-card-actions class="pt-10" v-if="!isUserEditable && !hideUpdateButton" data-testid="task-gl-selection__actions">
      <span class="caption red--text" data-testid="task-gl-selection__required-note">*Required</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" :loading="addeditloading" @click="addEditChecklistItem()" data-testid="task-gl-selection__update-btn">
        <span data-testid="task-gl-selection__update-btn-label">Update</span>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { getCustomColumns } from '../../../utils/utils.js';

export default {
  name: 'TaskEditDetails',
  props: {
    addeditdata: { type: Object, default: () => ({}) },
    addeditdataerror: { type: Object, default: () => ({}) },
    addeditdialog: { type: Boolean, default: false },
    customColumns: { type: Array, default: () => [] },
    selectgls: { type: Array, default: () => [] },
    searchcustomfilter: { type: String, default: '' },
    hideUpdateButton: { type: Boolean, default: false },
    isUserEditable: { type: Boolean, default: false },
  },
  data() {
    return {
      addeditloading: false,
      selectglsLocal: [],
      tempGlSelection: [],
      searchcustomfilterLocal: this.searchcustomfilter,
      // Phase 2: Debounce timer for TB search
      tbSearchTimer: null,
      tbSearchReady: false,
      // Track last searched value to prevent duplicate API calls
      lastSearchedValue: null,
    };
  },
  mounted() {
    console.log('Mounted TaskEditDetails with addeditdata:', this.addeditdata);
    // If linked GLs exist, sync them to selectglsLocal
    // Prefer __tbtotals.items (has glcodes) over __tblinks (has ObjectIDs)
    if (this.addeditdata && this.addeditdata.__tbtotals && Array.isArray(this.addeditdata.__tbtotals.items) && this.addeditdata.__tbtotals.items.length > 0) {
      this.selectglsLocal = this.addeditdata.__tbtotals.items.map(item => String(item.glcode));
      this.tempGlSelection = [...this.selectglsLocal];
      this.$emit('update:selectgls', this.selectglsLocal);
    } else if (this.addeditdata && Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
      // Fallback: __tblinks may contain glcodes (legacy)
      this.selectglsLocal = [...this.addeditdata.__tblinks].map(String);
      this.tempGlSelection = [...this.selectglsLocal];
      this.$emit('update:selectgls', this.selectglsLocal);
    }
    // --- Sync customfields into addeditdata for v-model binding ---
    console.log('Mounted TaskEditDetails with addeditdata:', this.addeditdata.priority, this.addeditdata.no_of_evidence);
    // Phase 2: Load first page of TB data via paginated API
    this.loadTbFirstPage();
    this.$nextTick(() => { this.tbSearchReady = true; });
  },
  beforeDestroy() {
    // Clear debounce timer
    if (this.tbSearchTimer) {
      clearTimeout(this.tbSearchTimer);
      this.tbSearchTimer = null;
    }
  },
  watch: {
    addeditdialog(val) {
      // Only update local selection when dialog is opened
      // Prefer __tbtotals.items (has glcodes) over __tblinks (has ObjectIDs)
      if (val) {
        if (this.addeditdata.__tbtotals && Array.isArray(this.addeditdata.__tbtotals.items) && this.addeditdata.__tbtotals.items.length > 0) {
          this.selectglsLocal = this.addeditdata.__tbtotals.items.map(item => String(item.glcode));
          this.tempGlSelection = [...this.selectglsLocal];
        } else if (Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
          this.selectglsLocal = [...this.addeditdata.__tblinks].map(String);
          this.tempGlSelection = [...this.addeditdata.__tblinks].map(String);
        }
      }
    },
    searchcustomfilterLocal() {
      // Always keep tempGlSelection as string IDs after search/filter
      this.tempGlSelection = (this.tempGlSelection || []).map(String);
    },
    'addeditdata.task_type'(newType) {
      if (newType === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        this.selectglsLocal = [];
        this.$emit('update:selectgls', this.selectglsLocal);
      }
    },
    'addeditdata.location'(newLocation, oldLocation) {
      // Reload TB data whenever location changes (including removal/clearing)
      // Don't reload if both are falsy (no change from null to null)
      if (newLocation !== oldLocation) {
        // Clear search filter and selections when location changes
        this.searchcustomfilterLocal = '';
        this.lastSearchedValue = null;
        
        if (newLocation) {
          // Location was set (or changed) - reload TB data
          this.loadTbFirstPage();
        } else {
          // Location was cleared - clear TB results to prevent stale data
          this.$store.commit('tasks/RESET_TB_STATE');
          this.selectglsLocal = [];
          this.tempGlSelection = [];
          this.$emit('update:selectgls', []);
        }
      }
    },
    selectgls(newVal) {
      // Sync parent prop changes to local state
      if (Array.isArray(newVal) && newVal.length > 0) {
        this.selectglsLocal = newVal.map(String);
        this.tempGlSelection = [...this.selectglsLocal];
      } else if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
        this.selectglsLocal = [];
        this.tempGlSelection = [];
      }
    },
    addeditdata(newData, oldData) {
      if (!newData) return;
      // Only re-sync GL selection when switching to a DIFFERENT task.
      // Same-task refreshes (after update/save) must NOT override the user's local chip state.
      const newId = newData._id;
      const oldId = oldData && oldData._id;
      if (newId && newId === oldId) return;
      // Prefer __tbtotals.items (has glcodes) over __tblinks (has ObjectIDs)
      if (newData.__tbtotals && Array.isArray(newData.__tbtotals.items) && newData.__tbtotals.items.length > 0) {
        this.selectglsLocal = newData.__tbtotals.items.map(item => String(item.glcode));
        this.tempGlSelection = [...this.selectglsLocal];
      } else if (Array.isArray(newData.__tblinks) && newData.__tblinks.length > 0) {
        this.selectglsLocal = newData.__tblinks.map(String);
        this.tempGlSelection = [...this.selectglsLocal];
      } else {
        this.selectglsLocal = [];
        this.tempGlSelection = [];
      }
      this.$emit('update:selectgls', [...this.selectglsLocal]);
    }
  },
    methods: {
    // Phase 2: Infinite scroll and paginated TB loading methods
    async loadTbFirstPage() {
      const projectId = this.addeditdata.project || this.$route.params.id || this.$route.params.projectId;
      if (!projectId) return;
      this.lastSearchedValue = null;
      this.$store.commit('tasks/RESET_TB_STATE');
      await this.$store.dispatch('tasks/fetchTbPage', {
        projectId,
        page: 1,
        limit: 50,
        location: this.addeditdata.location || null,
        search: null,
        append: false,
      });
    },
    onGlScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // Trigger next page when scrolled to 80% of container
      if (scrollTop + clientHeight >= scrollHeight * 0.8) {
        this.loadNextTbPage();
      }
    },
    async loadNextTbPage() {
      const tbLoading = this.$store.getters['tasks/isTbLoading'];
      const tbFullyLoaded = this.$store.getters['tasks/isTbFullyLoaded'];
      if (tbLoading || tbFullyLoaded) return;
      const tbPagination = this.$store.getters['tasks/getTbPagination'] || {};
      const currentPage = tbPagination.page || 1;
      const projectId = this.addeditdata.project || this.$route.params.id || this.$route.params.projectId;
      if (!projectId) return;
      await this.$store.dispatch('tasks/fetchTbPage', {
        projectId,
        page: currentPage + 1,
        limit: 50,
        location: this.addeditdata.location || null,
        search: this.searchcustomfilterLocal || null,
        append: true,
      });
    },
    debouncedTbSearch() {
      if (!this.tbSearchReady) return;
      // Skip if the search value hasn't actually changed (prevents duplicate calls on menu open)
      const searchVal = this.searchcustomfilterLocal || null;
      if (searchVal === this.lastSearchedValue) return;
      this.lastSearchedValue = searchVal;
      if (this.tbSearchTimer) clearTimeout(this.tbSearchTimer);
      this.tbSearchTimer = setTimeout(() => {
        const projectId = this.addeditdata.project || this.$route.params.id || this.$route.params.projectId;
        if (!projectId) return;
        // Reset and fetch from page 1 with search text
        this.$store.commit('tasks/RESET_TB_STATE');
        this.$store.dispatch('tasks/fetchTbPage', {
          projectId,
          page: 1,
          limit: 50,
          location: this.addeditdata.location || null,
          search: searchVal,
          append: false,
        });
      }, 300);
    },
    // GL removal logic
    removeSelectedGl(glcode) {
      if (!glcode) return;
      const glcodeStr = String(glcode);
      // Remove from both selectglsLocal and tempGlSelection (as strings)
      const newSelectGls = this.selectglsLocal.map(String).filter(code => code !== glcodeStr);
      const newTempGls = this.tempGlSelection.map(String).filter(code => code !== glcodeStr);
      this.selectglsLocal = newSelectGls;
      this.tempGlSelection = newTempGls;
      // Convert glcodes to _ids for __tblinks (backend expects object IDs)
      const tblinks = newSelectGls.map(code => this.glcodeToIdMap[String(code)] || String(code));
      this.$set(this.addeditdata, '__tblinks', tblinks);
      // Also update __tbtotals to reflect removal
      if (this.addeditdata.__tbtotals && Array.isArray(this.addeditdata.__tbtotals.items)) {
        const updatedItems = this.addeditdata.__tbtotals.items.filter(item => String(item.glcode) !== glcodeStr);
        const newTotal = updatedItems.reduce((sum, item) => {
          const amt = parseFloat(item.closing_amount);
          return sum + (isNaN(amt) ? 0 : amt);
        }, 0);
        this.$set(this.addeditdata, '__tbtotals', { total: newTotal, items: updatedItems });
      }
      this.$emit('update:selectgls', [...newSelectGls]);
    },
    // Only update tempGlSelection, chips update only on Select button click
    toggleSelectAllGl() {
      const filteredIds = this.filteredgllist.map(gl => String(gl.glcode));
      if (this.selectAllgl) {
        // Add all filteredgllist items to tempGlSelection (merge, avoid duplicates)
        this.tempGlSelection = Array.from(new Set([
          ...this.tempGlSelection.map(String),
          ...filteredIds
        ]));
      } else {
        // Remove only filteredgllist items from tempGlSelection
        this.tempGlSelection = this.tempGlSelection.map(String).filter(id => !filteredIds.includes(id));
      }
    },
    //  GL selection logic
    addSelectedGls() {
      // Set checked accounts to exactly what's selected (not merged)
      this.selectglsLocal = [...(this.tempGlSelection || [])].map(String);
      // Convert glcodes to _ids for __tblinks (backend expects object IDs)
      const tblinks = this.selectglsLocal.map(code => this.glcodeToIdMap[String(code)] || String(code));
      this.$set(this.addeditdata, '__tblinks', tblinks);
      // Update __tbtotals with selected items from TB records
      const glcodeItemMap = {};
      for (const item of this.tbComputed) {
        if (item && item.glcode != null) glcodeItemMap[String(item.glcode)] = item;
      }
      const selectedItems = [];
      let total = 0;
      for (const code of this.selectglsLocal) {
        const glItem = glcodeItemMap[String(code)];
        if (glItem) {
          selectedItems.push(glItem);
          if (glItem.closing_amount != null && glItem.closing_amount !== '') {
            const amt = parseFloat(glItem.closing_amount);
            if (!isNaN(amt)) total += amt;
          }
        }
      }
      this.$set(this.addeditdata, '__tbtotals', { total, items: selectedItems });
      this.$emit('update:selectgls', [...this.selectglsLocal]);
    },
    async addEditChecklistItem() {
      this.addeditloading = true;
      try {
        // Convert glcodes to _ids for backend payload
        const selectglsAsIds = this.selectglsLocal.map(code => this.glcodeToIdMap[String(code)] || String(code));
        const payload = {
          addeditdata: { ...this.addeditdata },
          customColumns: this.customColumnsComputed,
          selectglsLocal: selectglsAsIds,
        };
        const result = await this.$store.dispatch('tasks/addEditChecklistItem', payload);
        if (result && result.success) {
          this.$store.commit('sbSuccess', 'Tasklist item updated');
          this.$emit('checklist-item-updated', {
            data: {
              ...result.data,
              _id: this.addeditdata._id,
              __tblinks: selectglsAsIds,
              __tbtotals: this.addeditdata.__tbtotals,
            }
          });
          const checklistId = this.addeditdata.project || this.addeditdata._id;
          await this.$store.dispatch('tasks/getAllTasks', checklistId ? { checklistId } : {});
          this.$emit('refresh');
        } else {
          if (result && result.errorMessage) {
            this.$store.commit('sbError', result.errorMessage);
          } else if (result && result.data && result.data.index0) {
            this.addeditdataerror = result.data.index0;
            this.$store.commit('sbError', 'Validation error');
          } else {
            this.$store.commit('sbError', 'Unknown error!');
          }
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.log(err);
      } finally {
        this.addeditloading = false;
      }
    },
    refreshData() {
        // Emit event to parent to handle refresh
        this.$emit('refresh');
    },
  },
  computed: {
    taskListData() {
      return this.$store.getters['tasks/getTaskListData'] || {};
    },
    customColumnsComputed() {
      const checklist = this.taskListData.checklist || [];
      let mergedCustomFields = {};
      for (const item of checklist) {
        if (Array.isArray(item.customfields) && item.customfields.length > 0) {
          for (const fieldObj of item.customfields) {
            if (fieldObj && typeof fieldObj === 'object') {
              Object.assign(mergedCustomFields, fieldObj);
            }
          }
        }
      }
      try {
        return getCustomColumns(mergedCustomFields);
      } catch (e) {
        return [];
      }
    },
    filteredgllist() {
      // Phase 2: Use paginated tbRecords from store (search/pagination handled server-side)
      const tbRecords = this.$store.getters['tasks/getTbRecords'] || [];
      if (!Array.isArray(tbRecords) || tbRecords.length === 0) return [];

      const selectedLocationObj = this.locationMap[this.addeditdata.location] ||
        (this.taskListData.locationList || []).find(loc => loc._id === this.addeditdata.location);
      const isConsolidated = selectedLocationObj && selectedLocationObj.type === 'Consolidated';

      if (isConsolidated) {
        return tbRecords;
      }
      // Filter by location client-side
      return tbRecords.filter(item =>
        item.location_detail && item.location_detail.some(loc => loc._id === this.addeditdata.location)
      );
    },
    // Phase 2: Computed properties for TB loading state
    tbLoadingState() {
      return this.$store.getters['tasks/isTbLoading'] || false;
    },
    tbFullyLoadedState() {
      return this.$store.getters['tasks/isTbFullyLoaded'] || false;
    },
    tbComputed() {
      // Phase 2: Use paginated tbRecords from store
      const tbRecords = this.$store.getters['tasks/getTbRecords'] || [];
      return Array.isArray(tbRecords) ? tbRecords : [];
    },
    /**
     * O(1) location lookup map from store (backed by formDataV3).
     */
    locationMap() {
      return this.$store.getters['tasks/getLocationMap'] || {};
    },
    /**
     * O(1) glcode → _id lookup map from TB records (fetched via fetchTbPage)
     * AND from already-linked items in addeditdata.__tbtotals.items.
     * This ensures already-linked GLs have a stable mapping even before
     * their TB rows are paged in.
     */
    glcodeToIdMap() {
      const map = {};
      // First, seed from existing linked items (stable source for already-selected GLs)
      const tbtotals = this.addeditdata && this.addeditdata.__tbtotals;
      if (tbtotals && Array.isArray(tbtotals.items)) {
        for (const item of tbtotals.items) {
          if (item && item.glcode != null && item._id) {
            map[String(item.glcode)] = String(item._id);
          }
        }
      }
      // Then, overlay with tbComputed (paginated records) — these are authoritative when present
      const tb = this.tbComputed;
      for (const item of tb) {
        if (item && item.glcode != null && item._id) {
          map[String(item.glcode)] = String(item._id);
        }
      }
      return map;
    },
    selectAllgl: {
      get() {
        const tempIds = this.tempGlSelection.map(String);
        return this.filteredgllist.length > 0 && this.filteredgllist.every(item => tempIds.includes(String(item.glcode)));
      },
      set(val) {
        const filteredIds = this.filteredgllist.map(gl => String(gl.glcode));
        if (val) {
          this.tempGlSelection = Array.from(new Set([
            ...this.tempGlSelection.map(String),
            ...filteredIds
          ]));
        } else {
          this.tempGlSelection = this.tempGlSelection.map(String).filter(id => !filteredIds.includes(id));
        }
      }
    },
  }
}
</script>

<style>
.select-account__no .v-btn__content { display: flex !important; }
</style>